import { createRoot, hydrateRoot } from "react-dom/client";
import { PremiumRoot } from "./components/premium_root";
import { WithNonAuthedTrpcClient } from "../../misc/with-non-authed-trpc-client";

const initialData = (window as any).__INITIAL_DATA__;
const rootElement = document.getElementById("root");
const isDev = rootElement?.getAttribute("data-environment") === "development";

const App = () => (
	<WithNonAuthedTrpcClient>
		<PremiumRoot data={initialData} />
	</WithNonAuthedTrpcClient>
);

if (isDev) {
	const root = createRoot(rootElement);
	root.render(<App />);
} else {
	hydrateRoot(rootElement, <App />);
}
